import mammoth from "mammoth";

export async function extractFileText(file) {
  const fileName = file.name.toLowerCase();

  if (fileName.endsWith(".docx") || fileName.endsWith(".doc")) {
    return await extractWordText(file);
  }

  if (fileName.endsWith(".pdf")) {
    return await extractPdfText(file);
  }

  if (fileName.endsWith(".txt")) {
    return await file.text();
  }

  throw new Error("Unsupported file type. Please upload a PDF, Word (.docx), or .txt file.");
}

async function extractWordText(file) {
  const arrayBuffer = await file.arrayBuffer();
  const result = await mammoth.extractRawText({ arrayBuffer });
  return result.value.trim();
}

async function extractPdfText(file) {
  const pdfjsLib = await import("pdfjs-dist");
  pdfjsLib.GlobalWorkerOptions.workerSrc = "";

  const arrayBuffer = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({
    data: arrayBuffer,
    useWorkerFetch: false,
    isEvalSupported: false,
    useSystemFonts: true,
  }).promise;

  let fullText = "";
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const content = await page.getTextContent();
    const strings = content.items.map((item) => item.str);
    fullText += strings.join(" ") + "\n";
  }
  return fullText.trim();
}